import React from 'react';
import ConditionList from './ConditionList';
// import { addConditionToResponse, updateConditionToResponse, deleteConditionToResponse } from '../../store/modules/ResponseModule';

import { createCondition, updateCondition, deleteCondition } from '../Meta/ResponseMetaInfoAPI'

const ConditionListContainer = (props) => {
  const { conditions, responseUId, requestId } = props
  const { conditionActions } = props
  /**
   * Control conditions
   */
  let _addCondition = conditionActions.addCondition
  let _deleteCondition = conditionActions.deleteCondition
  let _updateCondition = conditionActions.updateCondition

  const handleAddCondition = (onSuccess) => {
    const last_condition_content = conditions[conditions.length-1].condition
    // Optional filtering
    if (!last_condition_content) {
      window.alert('마지막 컨디션의 내용이 비어있습니다.')
      return
    }

    // 빈 condition 인스턴스 추가
    createCondition((response) => {
      console.log('response :', response);
      const { data } = response
      if (!data) {
        return 
      }
      const { statusCode, property } = data
      switch(statusCode) {
        case 200:
          const { mapperID, condition } = property
          _addCondition({
            questionID: requestId,
            conditionText: condition,
            mapperId: mapperID,
          })
          onSuccess(mapperID)
        break;
        
        case 403:
          const { subCode } = data  
          if (subCode === 1) {
            window.alert('중복된 컨디션입니다.')
          } else {
            window.alert('서버에서 거부하였습니다.')
          }
        break;

        case 500:
          window.alert('서버에서 에러가 발생하였습니다.')
        break;

        default:
          window.alert('에러가 발생하였습니다.')
      }      

    }, responseUId, '')
  }

  const handleEditCondition = (id, value, onComplete) => {
    updateCondition((response) => {
      console.log('response :', response);
      const { data } = response
      if (!data) {
        return 
      }
      const { statusCode, property } = data
      switch(statusCode) {
        case 200:
          const { mapperID, condition } = property
          _updateCondition({
            questionID: requestId,
            conditionText: condition,
            mapperId: mapperID,
          })
        break;
        
        case 403:
          const { subCode } = data  
          if (subCode === 1) {
            window.alert('존재하지 않는 리스폰스입니다.')
          } else if (subCode === 2) {
            window.alert('중복된 컨디션입니다.')
          } else {
            window.alert('서버에서 거부하였습니다.')
          }
        break;

        case 500:
          window.alert('서버에서 에러가 발생하였습니다.')
        break;

        default:
          window.alert('에러가 발생하였습니다.')
      }      
      if (onComplete) {
        onComplete()
      }
    }, responseUId, id, value)
  }

  const handleDeleteCondition = (id, onComplete) => {
    deleteCondition((response) => {
      console.log('response :', response);
      const { data } = response
      if (!data) {
        return 
      }
      const { statusCode, property } = data
      switch(statusCode) {
        case 200:
          const { deletedMapperID, valueDeleted } = property
          _deleteCondition({
            questionID: requestId,
            mapperId: deletedMapperID,
            isValueDeleted: valueDeleted,
          })
        break;
        
        case 403:
          const { subCode } = data  
          if (subCode === 1) {
            window.alert('존재하지 않는 리스폰스입니다.')
          } else {
            window.alert('서버에서 거부하였습니다.')
          }
        break;

        case 500:
          window.alert('서버에서 에러가 발생하였습니다.')
        break;

        default:
          window.alert('에러가 발생하였습니다.')
      }
      if (onComplete) {
        onComplete()
      }
    }, responseUId, id)
  }

  return (
    <ConditionList
      conditions={conditions}
      addCondition={handleAddCondition}
      editCondition={handleEditCondition}
      deleteCondition={handleDeleteCondition}
    />
  )
}

const mapStateToProps = (state) => {
  // const conditions = state.ResponseModule.editCurrentResponse ? state.ResponseModule.editCurrentResponse.conditions : null
  // const responseId = state.ResponseModule.editCurrentResponse ? state.ResponseModule.editCurrentResponse.updateID : null
  // const qId = state.question.selectedQuestion ? state.question.selectedQuestion.id : null
  // return {
  //   conditions: conditions,
  //   responseUId: responseId,
  //   requestId: qId,
  // }
}

const mapDispatchToProps = (dispatch) => ({
  // _addCondition: (arg) => {dispatch(addConditionToResponse(arg))},
  // _updateCondition: (arg) => {dispatch(updateConditionToResponse(arg))},
  // _deleteCondition: (arg) => {dispatch(deleteConditionToResponse(arg))},
})

export default ConditionListContainer